import { useEffect, useState } from "react";
import { loadSchema } from "./lazy";
import { CalculationMethodType } from "__generated__/graphql";
import { RegistryItem } from "./schema";

type SchemaItem = NonNullable<RegistryItem[CalculationMethodType]>;

export function useSchema(type: CalculationMethodType | null): SchemaItem | null {
	const [ schema, setSchema ] = useState<SchemaItem | null>(null);

	useEffect(() => {
		if (type == null) {
			setSchema(null);
			return;
		}

		loadSchema(type).then((item) => {
			setSchema(item ?? null);
		}).catch(() => {
			setSchema(null);
		});

	}, [ type ]);

	return schema;
}
